import { Navigate, Route, Routes } from 'react-router-dom'
import type { ReactElement } from 'react'

import { Layout } from './components/Layout'
import { Spinner } from './components/ui'
import { useAuth } from './auth/AuthContext'
import { AuditPage } from './pages/AuditPage'
import { ChannelsPage } from './pages/ChannelsPage'
import { DashboardPage } from './pages/Dashboard'
import { EscalationPage } from './pages/EscalationPage'
import { IncidentDetailPage } from './pages/IncidentDetail'
import { IncidentsPage } from './pages/Incidents'
import { IntegrationsPage } from './pages/IntegrationsPage'
import { LoginPage } from './pages/Login'
import { RoutesPage } from './pages/RoutesPage'
import { SchedulesPage } from './pages/SchedulesPage'
import { TeamsPage } from './pages/TeamsPage'

function RequireAuth({ children }: { children: ReactElement }) {
  const { me, loading } = useAuth()
  if (loading) return <Spinner label="Проверяем сессию…" />
  if (!me) return <Navigate to="/login" replace />
  return children
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="incidents" element={<IncidentsPage />} />
        <Route path="incidents/:id" element={<IncidentDetailPage />} />
        <Route path="routes" element={<RoutesPage />} />
        <Route path="escalation" element={<EscalationPage />} />
        <Route path="teams" element={<TeamsPage />} />
        <Route path="schedules" element={<SchedulesPage />} />
        <Route path="integrations" element={<IntegrationsPage />} />
        <Route path="channels" element={<ChannelsPage />} />
        <Route path="audit" element={<AuditPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
